/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {NzBadgeSupComponent as ɵa} from './badge-sup.component';
export {NzRibbonComponent as ɵb} from './ribbon.component';